import { atom } from 'recoil'

export const isOpenDiscardConfigState = atom({
  key: 'isOpenDiscardConfigState',
  default: false
})
